// ========================================
// Emotion Data Constants
// ========================================
// Core emotions and life categories for Passage check-ins

export const CORE_EMOTIONS = [
  'Glad',
  'Sad',
  'Angry',
  'Fear',
  'Shame',
  'Guilty',
  'Hurt',
  'Lonely',
] as const;

export type CoreEmotion = (typeof CORE_EMOTIONS)[number];

export const LIFE_CATEGORIES = [
  'Physical',
  'Emotional',
  'Spiritual',
  'Financial',
  'Nutritional',
  'Sexual',
] as const;

export type LifeCategory = (typeof LIFE_CATEGORIES)[number];

export const AFFECTED_AREAS = [
  'Self-esteem',
  'Security',
  'Ambitions',
  'Personal relationships',
  'Sexual relationships',
  'Financial security',
] as const;

export type AffectedArea = (typeof AFFECTED_AREAS)[number];

// Emotion colors for visualization (calming palette)
export const EMOTION_COLORS: Record<CoreEmotion, string> = {
  Glad: '#FFD93D', // Warm yellow
  Sad: '#6BCB77', // Soft blue-green
  Angry: '#FF6B6B', // Coral red
  Fear: '#4ECDC4', // Turquoise
  Shame: '#95E1D3', // Mint
  Guilty: '#F38181', // Rose
  Hurt: '#AA96DA', // Lavender
  Lonely: '#FCBAD3', // Pink
};

// Category icons/symbols (using emoji for simplicity)
export const CATEGORY_ICONS: Record<LifeCategory, string> = {
  Physical: '💪',
  Emotional: '❤️',
  Spiritual: '✨',
  Financial: '💰',
  Nutritional: '🥗',
  Sexual: '🌹',
};

// Helper function to get emotion color
export const getEmotionColor = (emotion: string): string => {
  return EMOTION_COLORS[emotion as CoreEmotion] || '#9CA3AF';
};

// Helper function to get category icon
export const getCategoryIcon = (category: string): string => {
  return CATEGORY_ICONS[category as LifeCategory] || '📋';
};
